/* Craftsbazaar intent navigation — accessible tabs + reveal. Scoped to .cb-nav. */
(function () {
  'use strict';

  function initReveal(root) {
    root.classList.add('is-js');
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initTabs(root) {
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var panels = tabs.map(function (t) { return root.querySelector('#' + t.getAttribute('aria-controls')); });
    var current = 0;
    tabs.forEach(function (t, j) { if (t.getAttribute('aria-selected') === 'true') current = j; });

    function activate(i, focus) {
      current = i;
      tabs.forEach(function (t, j) {
        var sel = j === i;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
        if (panels[j]) panels[j].classList.toggle('is-active', sel);
      });
      if (panels[i]) {
        panels[i].querySelectorAll('.reveal').forEach(function (e) { e.classList.add('in'); });
      }
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('keydown', function (e) {
        var n = null, last = tabs.length - 1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = last;
        if (n !== null) { e.preventDefault(); activate(n, true); }
      });
    });

    /* swipe between panels (touch) */
    var box = root.querySelector('.panels');
    if (box && tabs.length > 1) {
      var x0 = 0, y0 = 0, tracking = false;
      box.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return; /* ignore taps + vertical scroll */
        if (dx < 0 && current < tabs.length - 1) activate(current + 1);      /* swipe left → next */
        else if (dx > 0 && current > 0) activate(current - 1);              /* swipe right → prev */
      }, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('.cb-nav').forEach(function (root) {
      initReveal(root);
      initTabs(root);
    });
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
